import createApp from './src/app.js'
import consentModeManager from './src/utils/consentMode'

// 在应用初始化之前，立即设置consent mode
// 这确保在任何Google代码加载之前就设置好consent默认状态
if (typeof window !== 'undefined') {
	console.log('[Entry] Initializing consent mode early...')
	consentModeManager.initializeConsentMode()
}

const { app, router, store } = createApp()

// // 检查是否存在服务器端注入的状态
if (window.__INITIAL_STATE__) {
	store.replaceState(window.__INITIAL_STATE__)
}

router.onReady(() => {
	// 挂载Vue实例时，将服务端的context注入
	app.$mount('#app')
})
